import { useApi } from '@/api';
import {
  CardList,
  Link,
  LinkButton,
  ListSkeleton,
  VaultName
} from '@/components';
import { CurrencyValue, Flex, ListItem } from '@blockanalitica/ui';

export default function TopLocked({ ...rest }) {
  const [data, error] = useApi({
    url: `/groups/seal/ilks/LSE-MKR-A/cdps/`,
    queryParams: {
      p_size: 3,
      order: '-ink',
      all: 1
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <CardList
        title="CDPs"
        action={
          <LinkButton size="small" to="cdps?what=wallets" variant="secondary">
            view all
          </LinkButton>
        }
        {...rest}>
        {data['results'].length > 0 &&
          data['results'].map((row) => (
            <ListItem
              variant="link"
              // @ts-ignore
              as={Link}
              key={row.urn}
              to={`cdps/${row.urn}`}>
              <Flex justifyContent="space-between">
                <VaultName cdp={row.cdp} urn={row.urn} />
                <Flex
                  flexDirection="column"
                  gap="3xs"
                  alignItems="flex-end"
                  justifyContent="center">
                  <CurrencyValue
                    value={row.ink}
                    options={{
                      currency: 'MKR',
                      iconSize: '0'
                    }}
                  />
                  {row.debt_change_1d > 0 ? (
                    <CurrencyValue
                      value={row.ink_change_1d}
                      options={{
                        trend: true
                      }}
                    />
                  ) : null}
                </Flex>
              </Flex>
            </ListItem>
          ))}
      </CardList>
    );
  }

  return <ListSkeleton {...rest} />;
}
